export const STUDENT_SESSION_KEY = "gear_student_session_id";
export const TEACHER_SESSION_KEY = "gear_teacher_session_id";
